export default "__VITE_ASSET__Cxi4ZXWW__"